(function() {
    'use strict';

    angular.module('app')
        .service('campaignService', campaignService);

    campaignService.$inject = ['$http'];

    function campaignService($http) {
        var apiUrl = '/api/campaignform';
        /* jshint validthis:true */
        var vm = this;

        function submitCampaignForm(formModel, pageId, blockId) {
            var model = angular.copy(formModel);
            model.pageId = pageId;
            model.blockId = blockId;

            return $http.post(apiUrl, JSON.stringify(model), { cache: false });
        }

        vm.submitCampaignForm = submitCampaignForm;
    }
})();